import moment from 'moment'

export const validateExpirationDate = ({ required = false } = {}) => (value) => {
  if (!value) {
    return required ? 'Expiration date is required' : undefined
  }

  // Strict parsing for MM/DD/YYYY
  const date = moment(value, 'MM/DD/YYYY', true)

  if (!date.isValid()) {
    return 'Date must be in MM/DD/YYYY format'
  }

  if (date.isBefore(moment(), 'day')) {
    return 'Date must be in the future'
  }

  return undefined
}
